import { render } from "./Severe_dizziness.vue?vue&type=template&id=609bfd53"
import script from "./Severe_dizziness.vue?vue&type=script&lang=js"
export * from "./Severe_dizziness.vue?vue&type=script&lang=js"

import "./Severe_dizziness.vue?vue&type=style&index=0&id=609bfd53&lang=scss"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__